import { render, staticRenderFns } from "./DefaultToggle.vue?vue&type=template&id=33fdcb79&scoped=true"
import script from "./DefaultToggle.vue?vue&type=script&lang=js"
export * from "./DefaultToggle.vue?vue&type=script&lang=js"
import style0 from "./DefaultToggle.vue?vue&type=style&index=0&id=33fdcb79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fdcb79",
  null
  
)

export default component.exports